import { render, staticRenderFns } from "./InvalidLink.vue?vue&type=template&id=fb07f6fa&scoped=true"
import script from "./InvalidLink.vue?vue&type=script&lang=js"
export * from "./InvalidLink.vue?vue&type=script&lang=js"
import style0 from "./InvalidLink.vue?vue&type=style&index=0&id=fb07f6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb07f6fa",
  null
  
)

export default component.exports